import { Component, Input, OnInit } from '@angular/core';
import { DataService ,RenderService} from 'rs-ng-core';

declare const projectCfg;
declare const Swiper;

@Component({
  selector: 'rs-ng-carousel',
  templateUrl: './rs-ng-carousel.component.html',
  styleUrls: ['./rs-ng-carousel.component.scss']
})
export class RsNgCarouselComponent implements OnInit {
	swiper;
	carouselData;
	interfaceCfg = JSON.parse(JSON.stringify(projectCfg['interfaceCfg']));
	@Input() data = { dataList : []};
	@Input() carouselParams;
	@Input() subComponent;
	@Input() styleName : 'style1' = 'style1';
	@Input() interfaceInfo;
	@Input() isInit;

  constructor(
	private dataService: DataService,
	private renderService: RenderService,
  ) { }

  ngOnInit(){
	this.initSwiper()
	if(this.isInit){
		this.getDataList()
	}
  }
  initSwiper(){
	this.swiper = new Swiper('.swiper', {
		// loop: this.carouselParams.loop,
		// æ ¹æ®sliderçå®½åº¦èªå¨åå¸
		slidesPerView: this.carouselParams.slidesPerView,
		loopedSlides: this.carouselParams.loopedSlides,
		slidesPerGroup:this.carouselParams.slidesPerGroup,
		  // activeä¸ å±ä¸­æ¾ç¤º
		//   centeredSlides: true,

		  // åé¡µ
		// pagination: {
		// 	el: '.swiper-pagination',
		// 	clickable: true,
		// },

		// åè¿åéæé®
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		observer: true,                       // ä¿®æ¹swiperèªå·±æå­åç´ æ¶ï¼èªå¨åå§åswiper
		observeParents: true,                 // ä¿®æ¹swiperçç¶åç´ æ¶ï¼èªå¨åå§åswiper
		});
  }
  prev() {
    this.swiper.slidePrev(this.carouselParams.prevSpeed,this.carouselParams.prevTransition);
  }
  next() {
    this.swiper.slideNext(this.carouselParams.nextSpeed,this.carouselParams.nextTransition);
  }
  getDataList() {
    const requestURL = this.interfaceInfo['indicator'];
    const paramList = this.interfaceCfg[requestURL]['params'];
    let paramObj = {};
	paramList.forEach(param => {
        paramObj[param] = this.interfaceInfo['param'][param] ;
    });

	for (let key in paramObj) {
        if (paramObj.hasOwnProperty(key)) {
          if (typeof paramObj[key] === 'undefined' || paramObj[key] === null) {
            delete paramObj[key];
          }
        }
      }

    this.dataService.getStatisticsData(
	  this.interfaceCfg[requestURL].url,
	  paramObj,
	  this.interfaceCfg[requestURL].type,

    ).subscribe(res => {
		console.log(res);
		this.carouselData = res.list
		if(res){
			const renderFn =this.interfaceInfo.renderFn;
			const carouselList = renderFn ? this.renderService[renderFn](this.carouselData) : this.carouselData;
			this.data= carouselList;
		}
    });
  };
}
